import { render, staticRenderFns } from "./chart-legend-card.vue?vue&type=template&id=57da6e1c&scoped=true&"
import script from "./chart-legend-card.vue?vue&type=script&lang=js&"
export * from "./chart-legend-card.vue?vue&type=script&lang=js&"
import style0 from "./chart-legend-card.vue?vue&type=style&index=0&id=57da6e1c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57da6e1c",
  null
  
)

component.options.__file = "chart-legend-card.vue"
export default component.exports